import { render, staticRenderFns } from "./TestEquipmentList.vue?vue&type=template&id=2b721400"
import script from "./TestEquipmentList.vue?vue&type=script&lang=ts"
export * from "./TestEquipmentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports